import React from 'react';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import { styled } from '@nykaa/ui-components';

import BelowTheFold from 'shared/components/BelowTheFoldControl';
import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';
import ShellLoader from '@nykaa/coupon-desktop/components/ShellLoader';
import {
  DEFAULT_COUPON_WIDTH,
  DEFAULT_COUPON_HEIGHT,
} from '@nykaa/coupon-desktop/constants';

const Loading = styled(AnimatedLoader)`
  height: 109px;
`;

const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "product.coupons" */ './Loadable'),
  {
    fallback: (
      <ShellLoader
        width={DEFAULT_COUPON_WIDTH}
        height={DEFAULT_COUPON_HEIGHT}
      />
    ),
  }
);

const ServerOptimized = () => (
  <BelowTheFold
    render={Loadable}
    loading={() => <Loading />}
  />
);
export default ServerOptimized;
